import Path from '@/utilities/bid/enums/Path'

// @ts-ignore
const guest = ({ to, next, store }): any => {
  if (to.path === Path.LOGIN) {
    return next()
  }
  if (store.getters['Auth/isLoggedIn'] === false) {
    return next()
  }

  return next(Path.LOGIN)
}

export default guest
